import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

const createEquipments = async (dataToSend: any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/equipments/create`, dataToSend,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const listEquipments = async (page : any, pageSize: any, sort: string, order: string, keyword: string, type_id:string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/equipments/list_all?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyword}&type_ids=${type_id}&id`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const listEquipmentTypes = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_equipment_types?sort=id&order=asc&status=active&keyword=&type_ids=&parent_area=&id`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listEquipmentFilter = async (type_id:string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/equipments/list_all?sort=&order=desc&status=active&keyword=&type_ids=${type_id}&id`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const changeEquipmentStatus = async (id: string, status: string , interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/equipments/change_status`, {
      id: id,
      status: status,
      interface_name: interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}


const equipments = {
    createEquipments,
    listEquipments,
    listEquipmentTypes,
    listEquipmentFilter,
    changeEquipmentStatus
};
  
  
export { equipments };